import { render } from "./SectionGiants.vue?vue&type=template&id=78e69168"
import script from "./SectionGiants.vue?vue&type=script&lang=js"
export * from "./SectionGiants.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__